import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';

interface DeltaProps {
  current: number;
  /** Last month's value; null/undefined = no comparison available */
  previous: number | null | undefined;
  /** e.g. "Sep" */
  label: string;
}

/**
 * Small month-over-month change ("▲ 4 vs Sep"). Neutral colors on purpose:
 * more Completed is good but more Ask My Accountant is not, so the arrow
 * only says which way the number moved.
 */
export default function Delta({
  current,
  previous,
  label,
}: Readonly<DeltaProps>) {
  if (previous === null || previous === undefined) return null;
  const diff = current - previous;
  const Icon = diff > 0 ? ArrowUpRight : diff < 0 ? ArrowDownRight : Minus;
  const text =
    diff === 0 ? `same as ${label}` : `${Math.abs(diff)} vs ${label}`;
  return (
    <span
      className="inline-flex items-center gap-0.5 text-[11px] font-medium text-slate-500"
      title={`${label}: ${previous}`}
      aria-label={
        diff === 0
          ? `Same as ${label}`
          : `${diff > 0 ? 'Up' : 'Down'} ${Math.abs(diff)} from ${label} (${previous})`
      }
    >
      <Icon className="h-3 w-3" aria-hidden />
      {text}
    </span>
  );
}
